﻿/**
 * YourPlan Card Block functionality
**/

(function ($) {
   $.fn.rlYPCardBlocks = function () {

       $('.contactblock .h4').matchHeight();
        
    }
}(jQuery));